
import React from "react";
import LayerFormFields from "./FeatureFormFields";
import { Box, Button, FormGroup, Typography, Stack } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";

const LayerForm = ({
  feature,
  schema,
  onChange,
  // onFocus,
  currentFocus,
  onDateTimePickerChange,
  save,
  cancel,
  delete_feature,
  formErrorMessage,
  formdisabled,
  isLoading,
  onAddressChange,
  onMapChange,
}) => (
  <div>
    <Box>
      {formdisabled ? (
        <div disabled>
          <LayerFormFields
            className="higher"
            feature={feature}
            schema={schema}
            onChange={onChange}
            // onFocus={onFocus}
            currentFocus={currentFocus}
            onDateTimePickerChange={onDateTimePickerChange}
            save={save}
            cancel={cancel}
            onAddressChange={onAddressChange}
            onMapChange={onMapChange}
          />
        </div>
      ) : (
        <div>
          <LayerFormFields
            className="higher"
            feature={feature}
            schema={schema}
            onChange={onChange}
            // onFocus={onFocus}
            currentFocus={currentFocus}
            onDateTimePickerChange={onDateTimePickerChange}
            save={save}
            cancel={cancel}
            onAddressChange={onAddressChange}
            onMapChange={onMapChange}
          />

          <br />

          <FormGroup>
            <Stack
              style={{ paddingTop: 50 }}
              direction="row"
              spacing={2}
              sx={{
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Button
                className="mr-sm-2"
                disabled={isLoading ? true : false}
                color="secondary"
                onClick={cancel}
                variant="contained"
                startIcon={<ArrowBackIcon />}
              >
                Cancel
              </Button>
              <Button
                disabled={
                  isLoading
                    ? true
                    : formErrorMessage.length === 0
                    ? false
                    : true
                }
                className="mr-sm-2"
                color="primary"
                onClick={save}
                variant="contained"
                startIcon={<SaveIcon />}
              >
                Save
              </Button>
              {feature.id !== "new" && isLoading === false ? (
                <Button
                  className="mr-sm-2"
                  variant="contained"
                  color="error"
                  onClick={delete_feature}
                  disabled={isLoading ? true : false}
                  startIcon={<DeleteIcon />}
                >
                  Delete
                </Button>
              ) : null}
            </Stack>

            {formErrorMessage.length > 0 ? (
              <Typography color="error">{formErrorMessage}</Typography>
            ) : null}
          </FormGroup>
        </div>
      )}
    </Box>
  </div>
);

export default LayerForm;
